<template>
    <div class="content">
    <!--头部-->
     <div style="overflow: hidden">
      <help-head></help-head>
        <router-view/>
     </div>
     </div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
    },

}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// help.vue?bb310070